export default {
  id: {
    asc: 'id_ASC',
    desc: 'id_DESC',
  },
  type: {
    asc: 'type_ASC',
    desc: 'type_DESC',
  },
  userId: {
    asc: 'userId_ASC',
    desc: 'userId_DESC',
  },
  status: {
    asc: 'status_ASC',
    desc: 'status_DESC',
  },
  effectiveDate: {
    asc: 'effectiveDate_ASC',
    desc: 'effectiveDate_DESC',
  },
};
